import { Collapse, Icon, IconName } from "@blueprintjs/core";
import classNames from "classnames";
import React from "react";
import "./CollapsibleSection.scss";

type CollapsibleSectionProps = {
    readonly title: string;
    readonly isOpen: boolean;
    readonly onToggle: () => void;
    readonly children: React.ReactNode;
    readonly isLocked?: boolean;
    readonly isLoading?: boolean;
    readonly className?: string;
};

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
    title,
    isOpen,
    onToggle,
    children,
    isLocked = false,
    isLoading = false,
    className
}) => {
    const isDisabled = isLoading || isLocked;

    const getIcon = (): IconName => {
        if (isLocked) {
            return "lock";
        }
        return isOpen ? "chevron-down" : "chevron-right";
    };

    return (
        <>
            <div
                className={classNames(
                    "CollapsibleSection-header",
                    {
                        "CollapsibleSection-clickable": !isDisabled
                    },
                    className
                )}
                onClick={!isDisabled ? onToggle : undefined}
            >
                <h6 className="bp5-heading">{title}</h6>
                <Icon className="bp5-text-muted" icon={getIcon()} />
            </div>
            <Collapse isOpen={!isDisabled && isOpen}>{children}</Collapse>
        </>
    );
};
